<ion-card-header class="header">
  <ion-card-title class="header__title">
    @if(icon) {
    <ion-icon
      size="large"
      class="sys_ver_icon success-message-system header__icon"
      [ngClass]="icon"
    ></ion-icon
    >} <div class="logo-styled" [innerHTML]="title | translate"></div></ion-card-title
  >
  <ion-card-subtitle class="header__subtitle">{{
    subtitle | translate
  }}</ion-card-subtitle>
</ion-card-header>
